import React from 'react';

import { CookiesProvider, Cookies } from 'react-cookie';

import {
  getUserProgramsFullRequest,
} from '../redux/reducers/userProgramsFull';
import { loginAdminRequest, logoutUserRequest } from '../redux/reducers/login';



const cookies = new Cookies();

const authHOC = WrappedComponent => {
  class HOC extends React.Component {
    getParameterByName(name) {
      var queryStringFromStartOfValue = window.location.search.split(name + '=')[1];
      return queryStringFromStartOfValue !== undefined ? queryStringFromStartOfValue.split('&')[0] : null;
      }
    componentWillMount() {
     
      const { history, loginReducer, getToken, authUser, loginAdminRequest, authAdmin } = this.props;
      const isUserLoggedIn = loginReducer.isLoggedIn;
      if (!isUserLoggedIn && this.getParameterByName('loginAs') == null) {
       
        history.replace('/');
        
      }else{
       
        try {
          console.log('LLLLx3',this.props)
           loginAdminRequest({userId:this.getParameterByName('userId'), firstName:this.getParameterByName('firstName'), lastName:this.getParameterByName('lastName'),email:this.getParameterByName('email'), avatar:this.getParameterByName('avatar'), numberOfUnreadMessages:this.getParameterByName('numberOfUnreadMessages')})
          
          } catch (error) {
          //console.log('LLLLx', error)
        }
      
      }
      if (!isUserLoggedIn) {
       // history.replace('/login');
      }
    
      if (isUserLoggedIn && (!loginReducer.token && !loginReducer.user && this.getParameterByName('loginAs') == null)) {
      
        getToken(cookies.get('tokenCoach'));
        authUser();
      }else if (isUserLoggedIn && (!loginReducer.token && !loginReducer.user && this.getParameterByName('loginAs') != null)){
        console.log('LLLLx7',cookies.get('tokenCoach'),{userId:this.getParameterByName('userId'), firstName:this.getParameterByName('firstName'), lastName:this.getParameterByName('lastName'),email:this.getParameterByName('email'), avatar:this.getParameterByName('avatar'), numberOfUnreadMessages:this.getParameterByName('numberOfUnreadMessages')})
        getToken(cookies.get('tokenCoach'));
        authAdmin({userId:this.getParameterByName('userId'), firstName:this.getParameterByName('firstName'), lastName:this.getParameterByName('lastName'),email:this.getParameterByName('email'), avatar:this.getParameterByName('avatar'), numberOfUnreadMessages:this.getParameterByName('numberOfUnreadMessages')});
      }else{
      
        logoutUserRequest(loginReducer.token)
      }
    }

    componentWillReceiveProps(nextProps) {
      const { history, loginReducer, match, getToken } = nextProps;
      const isUserLoggedIn = loginReducer.isLoggedIn;
      
      if (isUserLoggedIn && loginReducer.token !== null && cookies.get('tokenCoach') === undefined) {
       
        cookies.set('tokenCoach', loginReducer.token);
      }

      if (match.path !== '/' && !isUserLoggedIn) {
        console.log('LLLLMMMM', loginReducer.token)
        cookies.remove('tokenCoach');
        history.replace('/login');
        window.location.reload();
      }
      if (isUserLoggedIn && !loginReducer.token) {
      
        getToken(cookies.get('tokenCoach'));
      }
     
      if(loginReducer.user && nextProps.coachFull && !nextProps.coachFull.fetching && !nextProps.coachFull.isFetched){

        nextProps.getTeamMembersFullRequest()
      }
    }

    render() {
      return (
        <CookiesProvider>
          <WrappedComponent {...this.props} />
        </CookiesProvider>
      );
    }
  }

  return HOC;
};

export default authHOC;



// WEBPACK FOOTER //
// ./src/Components/AuthHOC.jsx